import { OptionalLink } from '../01-core/OptionalLink';

export interface TagProps {
  /** Tag label */
  label: string;
  /** Title on tag */
  title?: string;
  /** Link on tag */
  href?: string;
  /** Additional class */
  className?: string;
  /** Optional click handler */
  onClick?: () => void;
}

/** A tag */
export const Tag = ({ label, title, href, className, ...props }: TagProps) => {
  return (
    <OptionalLink
      button={true}
      div={true}
      className={['tag', className].join(' ')}
      href={href}
      title={title}
      {...props}
    >
      {label}
    </OptionalLink>
  );
};
